
<div style="position: relative">
    <c-card-iterator
        :items          = "filteredItems"
        :label          = "$t('todo.bounced.title')"
        :loading        = "loading"
        :title-prefix   = "true"
        :pagination-on  = "true"
        :item-height    = "76"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "72"
        :height         = "height"
        @search         = "onSearch"
    >
        <template v-slot:card="{ item }">
            <p-inc-bounced-mail-card
                :mail   = "item"
                @site   = "onSite"
                @mail   = "onMail"
            />
        </template>
    </c-card-iterator>

    <div v-if="!items || items.length === 0" class="lm-border empty-todos">
        <v-icon color="success" size="30">mdi-check-circle</v-icon>
    </div>
</div>
